var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowFile
    ? _c(
        "el-card",
        { staticClass: "u-m-b-20", attrs: { header: "投保盖章文件" } },
        [
          _c("avue-form", {
            ref: "fileForm",
            attrs: {
              option: _vm.optionFileConfirm,
              "upload-before": _vm.onUploadBefore,
            },
            on: { submit: _vm.onSubmitFileConfirm },
            scopedSlots: _vm._u(
              [
                {
                  key: "insureConfirmUrl",
                  fn: function (ref) {
                    return [
                      _vm.isNeedDeclareStart
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onDownLoadTemp },
                            },
                            [_vm._v("下载模板")]
                          )
                        : _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t按照相关监管要求，录单信息（被保企业、方案、人员等）变更后，务必\n\t\t\t\t\t"
                              ),
                              _c("span", { staticClass: "red-bold" }, [
                                _vm._v("重新下载盖章件，并线下盖章确认！"),
                              ]),
                            ]),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t你可以先暂存保单，等文件盖章后\n\t\t\t\t\t"
                              ),
                              _c("span", { staticClass: "red-bold" }, [
                                _vm._v("从暂存列表继续录单流程。"),
                              ]),
                            ]),
                          ]),
                    ]
                  },
                },
                {
                  key: "menuForm",
                  fn: function (ref) {
                    return [
                      !_vm.optionFileConfirm.submitBtn
                        ? _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.onIsSubmit(false)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              3062700786
            ),
            model: {
              value: _vm.formFileConfirm,
              callback: function ($$v) {
                _vm.formFileConfirm = $$v
              },
              expression: "formFileConfirm",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }